<template>
  <div ref="top_ads" class="top-ads ad-slot">
    <div class="ad_container">
      <div class="ad_wrapper">
        <!-- <div id="div-gpt-ad-1585758066805-0" v-if="screen.isDesktop"></div>
        <div id="div-gpt-ad-1556531810809-0" v-else></div> -->

        <div v-if="screen.isDesktop" id="div-gpt-ad-1585758066805-0"></div>
        <div v-else id="div-gpt-ad-1585749611991-0"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'top-ads',
  computed: {
    screen() {
      return this.$store.state.screen;
    },
  },
  mounted() {
    if (document.readyState == 'complete') {
      this.loadAds();
    } else {
      document.addEventListener(
        'scriptReady',
        () => {
          this.loadAds();
        },
        { once: true }
      );
    }
  },
  beforeDestroy() {
    googletag.cmd.push(() => {
      const slots = googletag.pubads().getSlots();
      slots.forEach((slot) => {
        const elId = slot.getSlotElementId();
        if (elId === 'div-gpt-ad-1585758066805-0' || elId === 'div-gpt-ad-1585749611991-0') {
          googletag.destroySlots([slot]);
          const el = document.getElementById(elId);
          if (el) {
            el.removeAttribute('data-slot-loaded');
          }
        }
      });
    });
  },
  methods: {
    loadAds() {
      const el = this;
      const isDesktop = this.$store.state.screen.isDesktop;
      const slotId = isDesktop ? 'div-gpt-ad-1585758066805-0' : 'div-gpt-ad-1585749611991-0';
      const adContainer = document.getElementById(slotId);
      if (!adContainer || adContainer.dataset.slotLoaded) {
        return;
      }

      googletag.cmd.push(() => {
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
          const id = event.slot.getSlotElementId();
          if (!id) {
            return;
          }
          const elRef = el.$refs['top_ads'];
          if (!elRef || !elRef.classList.contains('ad-slot')) {
            return;
          }
          elRef.style.display = event.isEmpty ? 'none' : 'block';
        });

        const slot = googletag.defineSlot(
          isDesktop ? '/187290464/Revamp-Desktop-TopbannerNew1' : '/187290464/Revamp_Mobile_TopBannernew',
          isDesktop ? [970, 250] : [320, 100],
          slotId
        );

        if (slot) {
          slot.addService(googletag.pubads()).setCollapseEmptyDiv(true);
          googletag.enableServices();
          googletag.display(slotId);
          adContainer.dataset.slotLoaded = 'true';
        }
      });
    },
  },
};
</script>

<style lang="scss">
.ad_container {
  text-align: center;
}

.ad_wrapper {
  display: inline-block;
  position: relative;
}

.top-ads {
  display: none;
  margin: 30px 0;
}

@media (max-width: 991px) {
  .top-ads {
    margin: 30px 0 16px;
  }
}
</style>
